module.exports = __webpack_public_path__ + "images/19132-EXT1-Cam08-aa923c796983ea035d9be0969f676fa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Carousel_2/19132-EXT1-Cam08.jpg
// module id = 751
// module chunks = 0